import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-box3-icon',
  templateUrl: './shopping-box3.component.html'
})
export class ShoppingBox3Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
